import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { PayrollConceptSelectFieldFragment } from 'generated/resources/graphql'

import { translations as roleLevelSalaryTranslations } from 'modules/contracts/components/FixFlow/lib/roleLevelSalaryTranslations'
import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import { useCrudDisclosure } from 'modules/contracts/hooks/useCrudDisclosure'
import { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'
import { translate } from 'modules/contracts/lib/translate'

import { AdditionalCompensationsList } from './AdditionalCompensationsList/AdditionalCompensationsList'
import { CreateAdditionalCompensationFormModal } from './CreateAdditionalCompensation'
import { DeleteAdditionalCompensation } from './DeleteAdditionalCompensation'
import { EditAdditionalCompensationFormModal } from './EditAdditionalCompensation'

type AdditionalCompensationListProps = {
  additionalCompensations: InMemoryAdditionalCompensation[]
  type: ContractFlowType
  payrollConcepts: PayrollConceptSelectFieldFragment[]
}

function ContractAdditionalCompensationList({
  additionalCompensations,
  type,
  payrollConcepts,
}: AdditionalCompensationListProps) {
  const {
    isEditing,
    onEdit,
    onClose,
    editValue,
    isCreating,
    onCreate,
    isDeleting,
    deleteValue,
    onDelete,
  } = useCrudDisclosure<InMemoryAdditionalCompensation>()
  const translations = roleLevelSalaryTranslations()

  const isReadOnly = type === 'fix'
  return additionalCompensations ? (
    <Box gap="s24">
      <Box>
        <Button onClick={onCreate} iconName="add" disabled={isReadOnly}>
          {translate(translations, 'add_compensation')}
        </Button>
      </Box>
      <AdditionalCompensationsList
        additionalCompensations={additionalCompensations}
        onEdit={!isReadOnly ? onEdit : undefined}
        onDelete={!isReadOnly ? onDelete : undefined}
        onRead={isReadOnly ? onEdit : undefined}
      />

      {isEditing && editValue ? (
        <EditAdditionalCompensationFormModal
          onClose={onClose}
          additionalCompensation={editValue}
          isEditable={!isReadOnly}
          payrollConcepts={payrollConcepts}
        />
      ) : (
        isCreating && (
          <CreateAdditionalCompensationFormModal
            onClose={onClose}
            payrollConcepts={payrollConcepts}
          />
        )
      )}

      {isDeleting && deleteValue && (
        <DeleteAdditionalCompensation additionalCompensation={deleteValue} onClose={onClose} />
      )}
    </Box>
  ) : null
}

export { ContractAdditionalCompensationList }
